export const getCurrentQuarter = () => {
  const month = new Date().getMonth() + 1;

  if (month <= 3) return 1;
  if (month <= 6) return 2;
  if (month <= 9) return 3;

  return 4;
};
